import React from 'react';
import { KeySquare, Layers, ScanLine, Wrench } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const SYSTEM_IMAGE = 'https://cdn.magicpatterns.com/uploads/6JDZGm5oFJVKQMTYDSfbEt/peptides_bonos_mockup-1.png';
const pillars = [{
  icon: ScanLine,
  title: 'Auditorías reales',
  detail: 'Meses de verificación de laboratorios, lotes y certificados de análisis.'
}, {
  icon: Layers,
  title: 'Sistema, no lectura',
  detail: 'Un manual de ejecución paso a paso, no teoría para subrayar.'
}, {
  icon: Wrench,
  title: 'Poder de compra',
  detail: 'Entra a la farmacia como experto, no como turista indefenso.'
}];
export function RevelationSection() {
  return <section className="relative w-full overflow-hidden bg-ink-900 py-14 sm:py-20 md:py-28" data-id="element-227" data-mp="emy7r2sko74u">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold-400/30 to-transparent" aria-hidden="true" data-id="element-228" data-mp="2dx6azc0vdxkr" />
      <div className="relative mx-auto max-w-6xl px-5 sm:px-6" data-id="element-229" data-mp="1c5sppzb1mj7k">
        <SectionHeading label="El Glitch Médico" icon={KeySquare} title={<>
              Bienvenido a la <span className="gold-text" data-id="element-231" data-mp="129z8i2mdq1jg">"Mesa de los Adultos"</span>
            </>} data-id="element-230" data-mp="1h685sympm4t8" />

        <div className="mt-9 grid items-center gap-9 sm:mt-14 sm:gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-232" data-mp="177rbbrokb82f">
          <div className="perspective-stage relative" data-id="element-233" data-mp="1uxvddum3qzrb">
            <div className="pointer-events-none absolute inset-0 hidden scale-95 rounded-full bg-[radial-gradient(circle,rgba(201,162,74,0.18),transparent_65%)] blur-2xl sm:block" aria-hidden="true" data-id="element-234" data-mp="1zwpxczvt2ud0" />
            <Reveal data-id="element-235" data-mp="1q4k4lnxqc8wr">
              <div className="preserve-3d glass-sheen ease-luxe relative overflow-hidden rounded-2xl border border-gold-400/35 shadow-[0_40px_90px_-30px_rgba(0,0,0,0.9),0_30px_70px_-30px_rgba(201,162,74,0.35)] transition-transform duration-500 sm:[transform:rotateY(-6deg)] sm:hover:[transform:rotateY(0deg)_scale(1.02)]" data-id="element-236" data-mp="1q40mo782xkiq">
                <img src={SYSTEM_IMAGE} alt="El sistema completo: el libro maestro rodeado de tablets y teléfonos mostrando protocolos, laboratorios y biomarcadores" width={1376} height={768} loading="lazy" decoding="async" sizes="(min-width: 1024px) 560px, 100vw" className="w-full" data-id="element-237" data-mp="2njti6130ummw" />
              </div>
            </Reveal>
            <div className="mt-3.5 flex items-center justify-center gap-2 font-mono text-[9.5px] uppercase tracking-[0.14em] text-ash sm:text-[10px]" data-id="element-238" data-mp="1ztz4xiesiw24">
              <span className="h-px w-8 bg-gold-400/40" aria-hidden="true" data-id="element-239" data-mp="1vtp22emaolrh" />
              Un solo sistema de operaciones
              <span className="h-px w-8 bg-gold-400/40" aria-hidden="true" data-id="element-240" data-mp="1qvdoptwsjt4i" />
            </div>
          </div>

          <div data-id="element-241" data-mp="1lwkau0dle03t">
            <Reveal data-id="element-242" data-mp="1cfhnoid62ct">
              <p className="text-[14.5px] leading-relaxed text-[#b3b8c1] sm:text-base" data-id="element-243" data-mp="1cyooa6h76c2">
                Existe un sistema paralelo. Un ecosistema donde los laboratorios de patente y las
                farmacias de compounding de élite entregan{' '}
                <span className="font-semibold text-bone" data-id="element-244" data-mp="b88piul517o9">la misma pureza</span> que usan los atletas
                olímpicos y los multimillonarios de Silicon Valley.
              </p>
            </Reveal>
            <Reveal delay={0.08} data-id="element-245" data-mp="3ep8rrescyo43">
              <p className="mt-4 text-[14.5px] leading-relaxed text-[#9ba1ac] sm:mt-5 sm:text-base" data-id="element-246" data-mp="3jpmzevq1rw1l">
                He destilado meses de auditorías, riesgos legales y pruebas de laboratorio en un solo
                Sistema de Operaciones.{' '}
                <span className="font-semibold text-gold-300" data-id="element-247" data-mp="3sjrr1hd09bi6">
                  No es un libro para leer; es una herramienta para ejecutar.
                </span>
              </p>
            </Reveal>

            <ul className="mt-7 space-y-2.5 sm:mt-9 sm:space-y-4" data-id="element-248" data-mp="3002v9ykwnbzw">
              {pillars.map(({
              icon: Icon,
              title,
              detail
            }, index) => <li key={title} data-id="element-249" data-mp="2byzjn5r7larr" data-mpi={index}>
                  <Reveal delay={0.06 + index * 0.06} data-id="element-250" data-mp="2bzslbsbb9a31">
                    <div className="flex items-start gap-4 rounded-xl border border-white/[0.07] bg-ink-850/70 p-4 transition-colors hover:border-gold-400/30" data-id="element-251" data-mp="2qn3ujnk0shzz">
                      <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-gold-400/30 bg-gold-400/[0.08]" data-id="element-252" data-mp="2lvcck1exjklg">
                        <Icon className="h-4 w-4 text-gold-300" strokeWidth={1.7} aria-hidden="true" data-id="element-253" data-mp="2upqphxbzmj1e" />
                      </span>
                      <div data-id="element-254" data-mp="34nobsfaae5rd">
                        <h3 className="text-sm font-semibold text-[#eae7e1]" data-id="element-255" data-mp="34lal0imn3fpm">{title}</h3>
                        <p className="mt-1 text-[13px] leading-relaxed text-ash" data-id="element-256" data-mp="1fab5ikim67nm">{detail}</p>
                      </div>
                    </div>
                  </Reveal>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}